import { COLOR, FONT_WEIGHT, mq, Tag as _Tag } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const TagFlexWrapRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const SaleTag = styled(_Tag)`
  font-weight: ${FONT_WEIGHT.BOLD};
  margin-right: 8px;
  // MEMO : 文字数が長くなって折り返しされたときのためにこのコンポーネント自体にmargin-bottomを指定する
  margin-bottom: 8px;
`;

export const ParSaleTagSubText = styled.p`
  font-size: 14px;
  font-weight: ${FONT_WEIGHT.NORMAL};
  color: ${COLOR.RED900.code};
  // MEMO : 文字数が長くなって折り返しされたときのためにこのコンポーネント自体にmargin-bottomを指定する
  margin-bottom: 8px;

  ${mq.sp} {
    font-size: 12px;
  }
`;
